import type { StateCreator } from 'zustand'

import type { AllSlices } from '../types'
import type { VipSlice } from '../types/vip'

export const createVipSlice: StateCreator<AllSlices, [], [], VipSlice> = set => ({
  vipLevel: null,
  vipAccount: null,
  setVipLevel: (vipLevel, account) => {
    set(state => ({
      vip: { ...state.vip, vipLevel, vipAccount: account },
    }))
  },
})
